// extracted by mini-css-extract-plugin
export default {"copyRightText":"DefaultLayout_copyRightText__jA-Gn"};